import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { Sizes } from "./constants";
import { TimerProps } from "./types";

export const details = {
  name: "Timer",
  description: "Simple timer to keep track of things",
  tags: ["Productivity"],
  category: "Widget",
  grid: Sizes,
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  defaultProps: {
    sound: "alarm-01",
  },
} as ElementDetails<TimerProps>;
